var map = {
	"./1120/exo-path-title-image.png": 3710,
	"./1120/exocrine-pancreas-pathophysiology.jpg": 2060,
	"./1120/exocrine-path-altImg.png": 6363,
	"./1129/1129-HANDEL-I_schematic.png": 3266,
	"./1129/pediatric-immune-tissue-development-handel-i.jpg": 4386,
	"./1138/omics-collection-banner.jpg": 6813,
	"./1408/1408_IMC_figure.jpg": 6332,
	"./1408/79-plex-imc-type-1-diabetes-isletimmune-interface.jpg": 3228,
	"./410/CFRD_JCI_header.jpg": 7134,
	"./410/CFRD_processing_schematic.jpg": 1315,
	"./410/cystic-fibrosis-related-diabetes-cfrd.jpg": 831,
	"./459/HANDELP_diagram.jpg": 4199,
	"./459/neonatal-development--early-life-pancreas-handel-p.jpg": 6735,
	"./508/HPAP_article.jpg": 752,
	"./508/HPAP_schematic.jpg": 7961,
	"./508/human-pancreas-analysis-program-hpap.jpg": 9817,
	"./525/nPOD_article.png": 2813,
	"./525/npod-case-6362.jpg": 6017,
	"./525/npod.jpg": 6826,
	"./531/HANDEL-P_cohort_img.jpg": 6723,
	"./531/HANDELP_diagram.jpg": 8732,
	"./531/neonatal-development--early-life-pancreas-handel-p.jpg": 1494,
	"./703/exocrine-pancreas-in-type-1-diabetes.jpg": 3603,
	"./703/exocrine_image.png": 8948,
	"./853/integrated-islet-distribution-program-iidp-banner.webp": 2142,
	"./853/integrated-islet-distribution-program-iidp-dataImg.jpg": 2565,
	"./853/integrated-islet-distribution-program-iidp.jpg": 1599,
	"./853/load1.jpg": 2890,
	"./853/load1.png": 3630,
	"./904/early-stage-type-2-diabetes.jpg": 8884,
	"./904/t2d-altImg.png": 1693,
	"./904/t2d-title-image.png": 2969,
	"./960/eadb-altImg.png": 7075,
	"./960/eadb-title-image.png": 7715,
	"./960/exeter-archival-diabetes-biobank-eadb.jpg": 3934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7357;